import { api_domain } from './config'

export const api = {
  initial_domain: api_domain,
  domain: `${api_domain}/api/`,
  routes: {
    data: {
      init: 'data/init',
      cities_autocomplete: 'data/autocomplete_cities',
      place_autocomplete: 'data/autocomplete_place',
      generic_search: 'data/autocomplete_generic/',
    },
    oauth: {
      init: 'oauth/init',
      place_autocomplete: 'oauth/autocomplete_place',
      callback: 'oauth/callback',
    },
    userCompanies: {
      getList: 'company/:company/users',
      invite: 'company/:company/users/invite',
      checkInvite: 'company/:company/users/invite/dryrun',
    },
    admin: {
      dashboard: 'admin/dashboard/',
    },
    account: {
      get: 'account',
      checkEmail: 'register/checkEmail',
      registerUser: 'register/user',
      registerCompany: 'register/company',
    },
    users: {
      list: 'users',
      impersonate: 'impersonate/:id',
      get: 'users/:id',
      role: 'company/:companyId/users/role/:userId',
      delete: 'company/:companyId/users/revoke/:invitationId',
    },
    invitations: {
      accept: 'users/invitation/bulk',
    },
    subscription: {
      estimate: 'pre_subscription/estimate',
      init_subscription: 'pre_subscription/init_subscription',
      subscribe: 'subscription/subscribe',
      subscribeCompany: 'subscription/subscribe/:id',
      subscribeFree: 'account/toggleAppAccess',
      listSubscriptionScreens: 'subscription/:id/screens',
      removeSubscriptionScreen: 'subscription/:id/screens/:idScreen',
      cancelSubscription: 'subscription/:id',
      getPre: 'pre_subscription',
      getPreEstimate: 'pre_subscription/estimate',
    },
    payment_methods: {
      list: 'payment_method/card',
      delete: 'payment_method/card/:id',
      create: 'payment_method/card',
      set_default: 'payment_method/card/default/:id',
    },
    payment: {
      list: 'payment',
    },
    dataSources: {
      list: 'companyImporter',
      listCompany: 'company/:companyId/companyImporter',
      get: 'companyImporter/:id',
      getCompany: 'company/:companyId/companyImporter/:id',
      update: 'companyImporter',
      updateCompany: 'company/:companyId/companyImporter',
    },
    importers: {
      list: 'importer',
      get: 'importer/:id',
      propose: 'importer/propose',
    },
    companies: {
      users: 'users/:userId/companies',
      list: 'company',
      get: 'company/:id',
      update: 'company',
      list_screens: 'company/:id/screen',
      checkAccess: 'company/:id/checkAccess',
      checkUpdatePermission: 'company/:id/checkUpdatePermission',
    },
    networks: {
      list: 'admin/network',
      get: 'admin/network/:id',
      add: 'admin/network',
      update: 'admin/network/:id',
    },
    prices: {
      list: 'admin/price',
      get: 'admin/price/:id',
      add: 'admin/price',
      update: 'admin/price/:id',
    },
    templates: {
      list: 'template',
      init: 'template/init/:id',
      update: 'template',
    },
    storage: {
      list: 'company/:company/storage',
      listFiles: 'company/:company/storage/files',
      upload: 'company/:company/storage/upload',
      remove: 'company/:company/storage/remove/:id',
    },
    screens: {
      list: 'screen',
      listCompany: 'company/:companyId/screen',
      list_select: 'company/:companyId/screen/list_select',
      get: 'screen/:id',
      update: 'screen',
      preAssociate: 'screen/pre_associate/:screen/:flow',
      pre_create: 'screen/pre_create',
      associate: 'screen/associate/:uuid/:token',
      sendCommand: 'screen/sendCommand/:token/:command',
      logsApp: 'screen/log_app/:id',
      takeScreenshot: 'screen/:id/previewShot/take',
      getScreenshots: 'screen/:id/previewShot',
      addFree: 'admin/screen/attachCompany/:companyId',
      deleteFreeScreen: 'admin/screen/:companyId',
      deleteMulti: 'subscription/:subId/company/:companyId/screens',
      admin: {
        dissociateScreen: 'admin/screen/:id/dissociate',
        dissociateFlow: 'admin/screen/:id/detach',
      },
      commands: {
        reject: 'screen/reject/:token',
      },
    },
    flows: {
      list: 'screen/flow',
      listCompany: 'company/:companyId/screen/flow',
      list_select: 'screen/flow/listSelect',
      associate_screen: 'screen/flow/associate/:screen/:flow',
      get: 'screen/flow/:id',
      getDataSource: 'screen/flow/sourceData/:id',
      init: 'screen/flow/init/:id',
      order: 'company/:companyId/screen/flow/order',
      remove: 'screen/flow/:id',
      removeFromCompany: 'company/:companyId/screen/flow/:id',
      removePart: 'screen/flow/part/:id',
      orderFlow: 'company/:companyId/screen/flow/order',
      list_models: 'screen/precreate_flow',
      transform_model: 'screen/precreate_flow/transform/:id/:rootFlowId',
      list_models_company: 'company/:companyId/screen/precreate_flow',
      transform_model_company: 'company/:companyId/screen/precreate_flow/transform/:id/:rootFlowId',
      previewUrl: 'screen/flow/previewUrl/:id',
      generateThumbnail: 'screen/flow/generate_thumbnail/:flowId',
      getAreaData: 'screen/flow/:flowId/:areaId/data',
      excludeAreaData: 'screen/flow/:flowId/:areaId/data/excludeAreaData/:id',
    },
    system: {
      updateHelp: 'config/help',
    },
  },
}
